 
  <app-navbar-windows></app-navbar-windows>
  <router-outlet></router-outlet>
 
